import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { SubtradeChannelDropdownComponent } from '../DomainData/SubtradeChannelDropdown.component';
import { TradeNameDropdownComponent } from '../DomainData/TradeNameDropdown.component';
import { TradeGroupDropdownComponent } from '../DomainData/TradeGroupDropdown.component';
import { ManagedByDropdownComponent } from '../DomainData/ManagedByDropdown.component';
import { GlobalCustomerDropdownComponent } from '../DomainData/GlobalCustomerDropdown.component';

@Component({
  selector: 'my-keyaccount-edit',
  templateUrl: './KeyAccountEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => KeyAccountEditComponent)}]
})
export class KeyAccountEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @Input() public record: ent.KeyAccount;

    @ViewChild(SubtradeChannelDropdownComponent) public subtradeChannelDropdownComponent: SubtradeChannelDropdownComponent;
    @ViewChild(TradeNameDropdownComponent) public tradeNameDropdownComponent: TradeNameDropdownComponent;
    @ViewChild(TradeGroupDropdownComponent) public tradeGroupDropdownComponent: TradeGroupDropdownComponent;
    @ViewChild(ManagedByDropdownComponent) public managedByDropdownComponent: ManagedByDropdownComponent;
    @ViewChild(GlobalCustomerDropdownComponent) public globalCustomerDropdownComponent: GlobalCustomerDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'code' : '',
          'name' : '',
          'subtradeChannel' : '',
          'tradeGroup' : '',
          'tradeName' : '',
          'primaryFranchiseGroup' : '',
          'overarchingProgramsGroup' : '',
          'secondaryFranchiseAgreementsGroup' : '',
          'onOffPromotionsGroup' : '',
          'managedBy' : '',
          'globalCustomer' : '',
          'inactive' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    subtradeChannelChange(event: any){
        
      if (event < 0){
        this.record.DefaultSubtradeChannelID = null;
      }
      else{
        this.record.DefaultSubtradeChannelID = event;
      }
    }

    tradeGroupChange(event: any){
        
      if (event < 0){
        this.record.DefaultTradeGroupID = null;
      }
      else{
        this.record.DefaultTradeGroupID = event;
      }
    }

    tradeNameChange(event: any){
        
      if (event < 0){
        this.record.DefaultTradeNameID = null;
      }
      else{
        this.record.DefaultTradeNameID = event;
      }
    }

    managedByChange(event: any){
        
      if (event < 0){
        this.record.ManagedByID = null;
      }
      else{
        this.record.ManagedByID = event;
      }
    }

    globalCustomerChange(event: any){
        
      if (event < 0){
        this.record.GlobalCustomerID = null;
      }
      else{
        this.record.GlobalCustomerID = event;
      }
    }
}